import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useAuth } from "../../../components/context/AuthContext";

import {
  createFreightCompany,
  updateFreightCompany,
  getFreightCompanyList,
  deleteFreightCompany,
} from "../../../api/director/navlunApi";

function DirectorNavlunCompanyPage() {
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);

  const [companyForm, setCompanyForm] = useState({
    id: "",
    companyName: "",
    contactName: "",
    email: "",
    phone: "",
    tags: "",
    mailPermission: true,
    isActive: true,
  });

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      setLoading(true);

      const response = await getFreightCompanyList(1, 100);

      if (response?.data?.success) {
        setCompanies(response.data.data || []);
      }
    } catch (error) {
      console.error("Navlun firma listesi alınırken hata:", error);
      alert("Navlun firma listesi alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const resetCompanyForm = () => {
    setCompanyForm({
      id: "",
      companyName: "",
      contactName: "",
      email: "",
      phone: "",
      tags: "",
      mailPermission: true,
      isActive: true,
    });
  };

  const handleCompanyChange = (e) => {
    const { name, value, type, checked } = e.target;

    setCompanyForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCompanySubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        companyName: companyForm.companyName,
        contactName: companyForm.contactName,
        email: companyForm.email,
        phone: companyForm.phone,
        tags: companyForm.tags
          ? companyForm.tags
              .split(",")
              .map((tag) => tag.trim())
              .filter(Boolean)
          : [],
        mailPermission: companyForm.mailPermission,
        isActive: companyForm.isActive,
      };

      let response;

      if (companyForm.id) {
        response = await updateFreightCompany({
          id: companyForm.id,
          ...payload,
        });
      } else {
        response = await createFreightCompany(payload);
      }

      if (response?.data?.success) {
        alert(response.data.message || "İşlem başarılı.");
        resetCompanyForm();
        await fetchCompanies();
      } else {
        alert(response?.data?.message || "İşlem başarısız.");
      }
    } catch (error) {
      console.error("Navlun firma kayıt hatası:", error);
      alert(
        error?.response?.data?.message || "Firma kaydedilirken hata oluştu."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditCompany = (company) => {
    setCompanyForm({
      id: company._id,
      companyName: company.companyName || "",
      contactName: company.contactName || "",
      email: company.email || "",
      phone: company.phone || "",
      tags: Array.isArray(company.tags) ? company.tags.join(", ") : "",
      mailPermission: Boolean(company.mailPermission),
      isActive: company.isActive !== false,
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteCompany = async (id) => {
    const ok = window.confirm(
      "Bu navlun firmasını silmek/pasife almak istiyor musun?"
    );

    if (!ok) return;

    try {
      setLoading(true);

      const response = await deleteFreightCompany(id);

      if (response?.data?.success) {
        alert(response.data.message || "Firma silindi.");
        await fetchCompanies();
      } else {
        alert(response?.data?.message || "İşlem başarısız.");
      }
    } catch (error) {
      console.error("Navlun firma silme hatası:", error);
      alert(error?.response?.data?.message || "Firma silinirken hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  return (
    <Layout>
      <div className="content-body" style={{ width: "100%", padding: "20px" }}>
        <div className="row mt-3 mb-4">
          <div className="col-lg-4 col-md-6 mb-3">
            <div
              className="card text-center h-100"
              style={{
                backgroundColor: "#e8f4ff",
                borderRadius: "12px",
                border: "none",
              }}
            >
              <div className="card-body">
                <h6 style={{ color: "#0066cc", fontWeight: "600" }}>
                  TOPLAM FİRMA
                </h6>
                <h2
                  style={{
                    color: "#0066cc",
                    fontSize: "2.2rem",
                    margin: "10px 0",
                  }}
                >
                  {companies.length}
                </h2>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-3">
            <div
              className="card text-center h-100"
              style={{
                backgroundColor: "#e6ffed",
                borderRadius: "12px",
                border: "none",
              }}
            >
              <div className="card-body">
                <h6 style={{ color: "#16803c", fontWeight: "600" }}>
                  AKTİF FİRMA
                </h6>
                <h2
                  style={{
                    color: "#16803c",
                    fontSize: "2.2rem",
                    margin: "10px 0",
                  }}
                >
                  {companies.filter((item) => item.isActive).length}
                </h2>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-3">
            <div
              className="card text-center h-100"
              style={{
                backgroundColor: "#fff3cd",
                borderRadius: "12px",
                border: "none",
              }}
            >
              <div className="card-body">
                <h6 style={{ color: "#856404", fontWeight: "600" }}>
                  MAİL İZİNLİ
                </h6>
                <h2
                  style={{
                    color: "#856404",
                    fontSize: "2.2rem",
                    margin: "10px 0",
                  }}
                >
                  {companies.filter((item) => item.mailPermission).length}
                </h2>
              </div>
            </div>
          </div>
        </div>

        <section className="app-user-list">
          <div className="row">
            <div className="col-12">
              <div
                className="card"
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                }}
              >
                <div className="card-header border-bottom p-4 d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="card-title m-0">Navlun Firma Yönetimi</h4>
                    <small className="text-muted">
                      Teklif gönderilecek lojistik firmalarını yönetin.
                    </small>
                  </div>

                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={fetchCompanies}
                    disabled={loading}
                  >
                    Yenile
                  </button>
                </div>

                <div className="card-body pt-3">
                  {loading && (
                    <div className="alert alert-info py-2">
                      İşlem yapılıyor...
                    </div>
                  )}

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="card border">
                        <div className="card-header">
                          <h5 className="m-0">
                            {companyForm.id ? "Firma Güncelle" : "Firma Ekle"}
                          </h5>
                        </div>

                        <div className="card-body">
                          <form onSubmit={handleCompanySubmit}>
                            <div className="mb-2">
                              <label className="form-label">Firma Adı</label>
                              <input
                                name="companyName"
                                className="form-control"
                                value={companyForm.companyName}
                                onChange={handleCompanyChange}
                                required
                              />
                            </div>

                            <div className="mb-2">
                              <label className="form-label">Yetkili Kişi</label>
                              <input
                                name="contactName"
                                className="form-control"
                                value={companyForm.contactName}
                                onChange={handleCompanyChange}
                              />
                            </div>

                            <div className="mb-2">
                              <label className="form-label">E-posta</label>
                              <input
                                name="email"
                                type="email"
                                className="form-control"
                                value={companyForm.email}
                                onChange={handleCompanyChange}
                                required
                              />
                            </div>

                            <div className="mb-2">
                              <label className="form-label">Telefon</label>
                              <input
                                name="phone"
                                className="form-control"
                                value={companyForm.phone}
                                onChange={handleCompanyChange}
                              />
                            </div>

                            <div className="mb-2">
                              <label className="form-label">Etiketler</label>
                              <input
                                name="tags"
                                className="form-control"
                                value={companyForm.tags}
                                onChange={handleCompanyChange}
                                placeholder="karayolu, avrupa"
                              />
                            </div>

                            <div className="form-check mb-2">
                              <input
                                id="mailPermission"
                                name="mailPermission"
                                type="checkbox"
                                className="form-check-input"
                                checked={companyForm.mailPermission}
                                onChange={handleCompanyChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="mailPermission"
                              >
                                Mail izni var
                              </label>
                            </div>

                            <div className="form-check mb-3">
                              <input
                                id="isActive"
                                name="isActive"
                                type="checkbox"
                                className="form-check-input"
                                checked={companyForm.isActive}
                                onChange={handleCompanyChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="isActive"
                              >
                                Aktif
                              </label>
                            </div>

                            <div className="d-flex gap-2">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                              >
                                {companyForm.id ? "Güncelle" : "Kaydet"}
                              </button>

                              {companyForm.id && (
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={resetCompanyForm}
                                >
                                  Vazgeç
                                </button>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-8">
                      <div className="table-responsive">
                        <table className="table table-hover table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th>Firma</th>
                              <th>Yetkili</th>
                              <th>E-posta</th>
                              <th>Telefon</th>
                              <th>Etiket</th>
                              <th>Mail</th>
                              <th>Durum</th>
                              <th>İşlem</th>
                            </tr>
                          </thead>
                          <tbody>
                            {companies.length > 0 ? (
                              companies.map((company) => (
                                <tr key={company._id}>
                                  <td className="fw-bold">
                                    {company.companyName}
                                  </td>
                                  <td>{company.contactName || "-"}</td>
                                  <td>{company.email || "-"}</td>
                                  <td>{company.phone || "-"}</td>
                                  <td>
                                    {Array.isArray(company.tags)
                                      ? company.tags.join(", ")
                                      : "-"}
                                  </td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        company.mailPermission
                                          ? "bg-success"
                                          : "bg-secondary"
                                      }`}
                                    >
                                      {company.mailPermission
                                        ? "İzinli"
                                        : "Kapalı"}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        company.isActive
                                          ? "bg-success"
                                          : "bg-secondary"
                                      }`}
                                    >
                                      {company.isActive ? "Aktif" : "Pasif"}
                                    </span>
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-sm btn-primary me-1"
                                      onClick={() => handleEditCompany(company)}
                                    >
                                      Düzenle
                                    </button>
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() =>
                                        handleDeleteCompany(company._id)
                                      }
                                    >
                                      Sil
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center p-4">
                                  Kayıt bulunamadı.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default DirectorNavlunCompanyPage;
